import { Link } from "react-router-dom";

const spinnerStyle = {
  display: "inline-block",
  width: 14,
  height: 14,
  marginRight: 8,
  border: "2px solid rgba(255,255,255,0.4)",
  borderTopColor: "#fff",
  borderRadius: "50%",
  animation: "nextBtnSpin 0.7s linear infinite",
  verticalAlign: "middle",
};

const NextButton = ({
  buttonTagCssClasses,
  buttonText,
  onClick = null,
  to = "",
  disabled = false,
  loading = false,
}) => {
  const isDisabled = disabled || loading;
  const content = (
    <>
      {loading && <span style={spinnerStyle} aria-hidden="true" />}
      {loading ? "Saving..." : buttonText}
      {!loading && <i className="material-icons dp48">arrow_forward</i>}
    </>
  );
  const className = `waves-effect waves-light btn btn-clear ${buttonTagCssClasses}${
    isDisabled ? " disabled" : ""
  }`;
  const style = isDisabled
    ? { opacity: 0.7, cursor: "not-allowed", pointerEvents: "none" }
    : undefined;

  return (
    <>
      <style>{`@keyframes nextBtnSpin { to { transform: rotate(360deg); } }`}</style>
      {to ? (
        <Link to={isDisabled ? "#" : to}>
          <button
            className={className}
            onClick={isDisabled ? undefined : onClick}
            disabled={isDisabled}
            style={style}
          >
            {content}
          </button>
        </Link>
      ) : (
        <button
          className={className}
          onClick={isDisabled ? undefined : onClick}
          disabled={isDisabled}
          style={style}
        >
          {content}
        </button>
      )}
    </>
  );
};

export default NextButton;
